import React, {useEffect, useRef, useState} from 'react';
import {Surcouche} from './CarteLeaflet.js';
import {IconeLecture, IconePause} from './CarteUi.js';
import {NAVY} from '../../tokens.js';
import {ajouterJours, anneesCurseur, dateFr, joursEntre} from './carte.selectors.js';

const PAS_LECTURE_MS = 150; // 1 jour / 150 ms

/**
 * R8 : curseur temporel centré en bas (560 px). Ne modifie que `at` (via `onChange`) ; la page recolore les marqueurs
 * avec `etatsDesPav` (mémoïsé). Bornes = `bornesCurseur` (première donnée -> aujourd'hui), pas = 1 jour.
 */
export default function CarteCurseur({bornes, at, onChange}) {
    const [lecture, setLecture] = useState(false);
    const atRef = useRef(at);
    atRef.current = at;
    const onChangeRef = useRef(onChange);
    onChangeRef.current = onChange;

    useEffect(() => {
        if (!lecture) return undefined;
        const id = setInterval(() => {
            const suivant = ajouterJours(atRef.current, 1);
            if (suivant > bornes.max) {
                setLecture(false);
                return;
            }
            atRef.current = suivant;
            onChangeRef.current(suivant);
        }, PAS_LECTURE_MS);
        return () => clearInterval(id);
    }, [lecture, bornes.max]);

    const demarrerOuPauser = () => {
        if (lecture) {
            setLecture(false);
            return;
        }
        if (at >= bornes.max) onChange(bornes.min); // en fin de course : on relit depuis le début
        setLecture(true);
    };

    const annees = anneesCurseur(bornes);
    const aujourdhui = at === bornes.max;
    return (
        <Surcouche
            style={{left: '50%', bottom: 16, transform: 'translateX(-50%)', width: 560, maxWidth: 'calc(100% - 32px)', boxSizing: 'border-box', padding: '10px 16px 8px', background: '#FFFFFF', border: '1px solid #E3E7EC', borderRadius: 16, boxShadow: '0 1px 2px rgba(16,46,105,.06), 0 1px 3px rgba(16,46,105,.05)', display: 'flex', flexDirection: 'column', gap: 4, fontSize: 12, color: '#2D333B'}}
        >
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <span style={{color: '#6B7480'}}>État du parc au</span>
                <span style={{fontWeight: 700}} aria-live="off">{dateFr(at)}{aujourdhui ? " · aujourd'hui" : ''}</span>
                <button
                    type="button"
                    aria-label={lecture ? "Mettre l'évolution en pause" : "Lire l'évolution"}
                    onClick={demarrerOuPauser}
                    disabled={bornes.jours === 0}
                    style={{width: 26, height: 26, border: '1px solid #D5DAE1', borderRadius: 999, background: '#FFFFFF', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#2D333B', cursor: bornes.jours === 0 ? 'default' : 'pointer'}}
                >
                    {lecture ? IconePause : IconeLecture}
                </button>
            </div>
            <label style={{display: 'flex', flexDirection: 'column', gap: 2}}>
                <span style={{position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)'}}>Date de l'instantané</span>
                <input
                    type="range"
                    min={0}
                    max={bornes.jours}
                    step={1}
                    value={joursEntre(bornes.min, at)}
                    disabled={bornes.jours === 0}
                    onChange={(e) => onChange(ajouterJours(bornes.min, Number(e.target.value)))}
                    style={{width: '100%', margin: 0, accentColor: NAVY}}
                />
                <span style={{display: 'flex', justifyContent: 'space-between', fontSize: 10, color: '#6B7480'}}>
                    {annees.map((a) => <span key={a}>{a}</span>)}
                </span>
            </label>
        </Surcouche>
    );
}
